import { createContext, useCallback, useEffect, useState } from "react";
import { ILoadingContext, ILoadingProps } from "./loading.interface";
import { useIsFetching, useIsMutating } from "react-query";
import { delay } from "../../helpers/utils";

const loadingInitValues: ILoadingContext = {
    isLoading: true,
    setIsLoading: Function.prototype(),
    hasLoading: true
};

export const LoadingContext = createContext<ILoadingContext>(loadingInitValues);

const LoadingProvider = ({ children }: ILoadingProps) => {
    const isFetching = useIsFetching();
    const isMutating = useIsMutating();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [hasLoading, setHasLoading] = useState<boolean>(true);

    const removeScreen = useCallback(async () => {
        if (!isFetching && !isMutating && hasLoading) {
            setHasLoading(false);
        }
    }, [isFetching, isMutating, hasLoading]);

    useEffect(() => {
        if (isLoading) setHasLoading(true);
        else delay(500).then(removeScreen);
    }, [isLoading, isFetching, isMutating, removeScreen]);

    useEffect(() => {
        if (isFetching) setIsLoading(true);
        else setIsLoading(false);
    }, [isFetching]);

    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading, hasLoading }}>
            {children}
        </LoadingContext.Provider>
    );
};

export default LoadingProvider;
